import { useState } from 'react';
import { Outlet, Link, NavLink } from 'react-router-dom';
import logo from '@/assets/docs_logo@255px.png';
import styles from './Layout.module.css';

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const year = new Date().getFullYear();

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          <Link to="/" className={styles.logoLink}>
            <img src={logo} alt="Dr. Davis Ice Cream" className={styles.logoImage} />
          </Link>

          <button
            className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>

          <ul className={`${styles.navLinks} ${menuOpen ? styles.navLinksOpen : ''}`}>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
                end
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                Contact
              </NavLink>
            </li>
            <li>
              <a
                href="https://www.facebook.com/Doc-Davis-Ice-Cream-Stand-115542725133788/"
                className={styles.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <h1 className={styles.footerHeading}>Family Owned and Operated</h1>
        <h1 className={styles.footerHeading}>Est. 1939</h1>
        <img src={logo} alt="Dr. Davis Ice Cream logo" className={styles.footerLogo} />
        <p className={styles.footerText}>67 Hollis St. Pepperell MA</p>
        <p className={styles.footerText}>Call: 978-433-6315</p>
        <p className={styles.footerText}>Stay Connected</p>
        <nav className={styles.footerSocial}>
          <a href="https://www.facebook.com/Doc-Davis-Ice-Cream-Stand-115542725133788/" target="_blank" rel="noopener noreferrer">Facebook</a>
          {' '}
          <a href="https://www.instagram.com/drdavisicecream/" target="_blank" rel="noopener noreferrer">Instagram</a>
          {' '}
          <a href="https://twitter.com/DrDavisIceCream" target="_blank" rel="noopener noreferrer">Twitter</a>
        </nav>
        <p className={styles.footerText}>&copy; {year} Dr. Davis Ice Cream</p>
      </footer>
    </div>
  );
}

export default Layout;
